import { Observable } from 'rxjs'
import { FulfillmentSubmitOrder } from '../models/fulfillment-submit-order'
import { FulfillmentDataResponse } from '../models/fulfillment-data-response'
import { FulfillmentOrderDetailModel } from '../models/fulfillment-order-details'
import { UserProfileBasic } from '../../user-management/models/user-profile-basic'
import { FulfillmentOrderDetailAll } from '../models/fulfillment-order-detail-all'
import { FulfillmentAppFeatureSetting } from '../models/fulfillment-app-feature-setting'
import { FulfillmentCriteria } from '../models/fulfillment-criteria'
import { FulfillmentSubmitOrderResponse } from '../models/fulfillment-submit-order-response'

export abstract class FulfillmentGateway {
    private _fulfillmentCriteria: FulfillmentCriteria = new FulfillmentCriteria()

    //    abstract submitOrder(fulfillmentSubmitOrder: FulfillmentSubmitOrder): Observable<FulfillmentDataResponse>
    abstract submitOrder(fulfillmentSubmitOrder: FulfillmentSubmitOrder): Observable<FulfillmentSubmitOrderResponse>
    abstract getFulfillmentOrderDetail(agentID: string, eventID: number): Observable<FulfillmentOrderDetailAll>
    abstract getFulfillmentOrderDetails(agentID: string, orgID: number, planYear: number): Observable<FulfillmentOrderDetailModel[]>
    abstract getUserProfile(userProfileName: string): Observable<string>
    abstract changeOrderStatus(eventID: number, status: string, loginID: string): Observable<string>
    abstract getFulfillmentAppFeatureSettings(featureID: number, orgID: number): Observable<FulfillmentAppFeatureSetting[]>
    abstract getOrderHistory(fulfillmentCriteria: FulfillmentCriteria): Observable<FulfillmentOrderDetailModel[]>
    abstract getEnrollmentEffectiveDateByOrgID(orgID: number, PlanYear: string): Observable<string>
    abstract getOrderHistorySync(fulfillmentCriteria: FulfillmentCriteria)
    get fulfillmentCriteria(): FulfillmentCriteria {
        return this._fulfillmentCriteria
    }
    set fulfillmentCriteria(value: FulfillmentCriteria) {
        this._fulfillmentCriteria = value
    }
}
